$(document).on('submit', '#searchForm', function (e) {
    e.preventDefault();
    var searchInput = $('#searchBar').val();
    var url = "/search/" + searchInput;
    // console.log(url);
    window.location.href = url;
});